export default class TimeSlot {
    public id: number;

    public start: Date;

    public end: Date;

    constructor(id: number, start: Date, end: Date) {
      this.id = id;
      this.start = start;
      this.end = end;
    }
}
